import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleAnalyticsService } from './services';

@NgModule({
  imports: [CommonModule],
  providers: [GoogleAnalyticsService],
})
export class UserAnalyticsModule {}
